namespace TR {

    'use strict';

    class HolidayDealsResults {

        page: Function;
        paging: any;
        results: any;
        showSearchUnit: boolean;
        updating: boolean;
        dealsSortCriteria: any;
        sortCriterion: number;
        showMap: boolean;
        priceMode: number;
        getCoordinates: any;
        showFilterBox: any;
        newSearch: boolean;

        constructor(
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private holidayDeals: any,
            private broker: any,
            private pagingService: Core.PagingService,
            private resourceService: Core.ResourceService,
            private analytics: any,
            bd4t: any,
            sortCriteria: any
        ) {
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-holidayDealsResults'
            });

            bd4t('send','pageview', { type: 'deals', label: 'dealsFinderResults' });

            this.page = (page) => this.find(page - 1, this.sortCriterion);
            this.sortCriterion = sortCriteria.getSort() || 1;
            this.priceMode = 0;
            this.newSearch = true;
            this.showSearchUnit = !!_.get(this.$location.search(), 'promo');
            broker.publish('priceModeChanged', this.priceMode);

            broker.subscribe(
                'holidayDealsResults',
                'REFRESHSEARCH',
                (e:any) => {
                    this.newSearch = (e && e.data) ? e.data.newSearch : false;
                    this.find(0, this.sortCriterion);
                }
            );

            broker.subscribe(
                'holidayDealsResults',
                'priceModeChanged',
                e => this.priceMode = e.data
            );

            // This also starts the first search
            $scope.$watch(
                'hd.sortCriterion',
                (v:number) => {
                    this.find(0, v).then(() => sortCriteria.saveSort(v));
                }
            );

            this.dealsSortCriteria = sortCriteria.getDealsCriteria();

            $scope.$on('$destroy', () => {
                broker.unsubscribe('holidayDealsResults');
            });

            broker.publish('priceModeChanged', 1);
        }

        toggleSearchUnit() {
            this.showSearchUnit = !this.showSearchUnit;
        }

        toggleMap() {
            this.showMap = !this.showMap;
        }

        isFiltered() {
            if (!this.results) { return false; }
            return !_.isEqual(
                this.results.Info.filters,
                this.holidayDeals.getDefaultFilters()
            );
        }

        resetFilters() {
            this.results.Info.filters = this.holidayDeals.getDefaultFilters();
        }

        openSlideFilter() {
            this.showFilterBox = true;
        }

        find(page = 0, sort = 1) {
            this.updating = true;
            return this.holidayDeals
                .find({ page, sort })
                .then(res => this.results = res)
                .then(() => {
                    this.broker.publish(
                        'hotelsReturnedFromSearch',
                        this.results.Products.filter(p => !p.IsCruise)
                    );
                    this.broker.publish('UPDATEMAP');
                })
                .then(() => {
                    this.paging = this.pagingService.data(
                        this.results.Paging.Index + 1,
                        this.results.Paging.Size,
                        this.results.Paging.Total);
                    this.paging.UnfilteredTotal = this.results.Paging.UnfilteredTotal;
                    this.updating = false;
                    this.$scope.$emit('unblock');

                    if (_.has(this.$location.search(), 'openBox')) {
                        const hotel = _.first(this.results.Products.filter(p => !p.IsCruise));
                        if (hotel) { this.broker.publish('SHOWDEALS', { hotel }); }
                    }

                    if (this.newSearch) {
                        this.analytics.track('mixpanel', 'HolidayDealsListing', {
                            cruiseCount: (this.results.Products.filter(p => p.IsCruise) || []).length,
                            hotelCount: (this.results.Products.filter(p => !p.IsCruise) || []).length
                        });
                        this.newSearch = false;
                    }

                    if (sort !== 1) {
                        const sortElement =
                            _.find(
                                this.dealsSortCriteria,
                                (s:any) => s.val.indexOf(sort) > -1
                            );

                        if (!sortElement) { return; }

                        const dir = _.min(sortElement.val) === sort ? 'asc' : 'desc';

                        this.analytics.track('mixpanel', 'HolidayDealsSort', {
                            'ChangedTo': `${sortElement.name()} ${dir}`
                        });

                    }
                }, () => this.$scope.$emit('unblock'));
        }
    }

    angular
        .module('TR')
        .controller('HolidayDealsResults', HolidayDealsResults);
}
